<script lang="ts">
    import InvertibleMask from '@amp/web-app-components/src/components/InvertibleMask/InvertibleMask.svelte';
    import InfoIcon from '~assets/icons/info-circle.svg';
    import InfoFillIcon from '~assets/icons/info-circle-fill.svg';
    import { getI18n } from '~/stores/i18n';

    export let isSelected: boolean = false;

    const i18n = getI18n();

    const ariaLabel = $i18n.t('ASE.Web.MusicClassical.UpNext.Info');
</script>

<button
    data-testid="info-button"
    aria-label={ariaLabel}
    class="toggle-button toggle-button--info"
    on:click
>
    <InvertibleMask
        maskSvg={isSelected ? InfoFillIcon : InfoIcon}
        maskWidth={22}
        maskHeight={22}
        inverted={isSelected}
    />
</button>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    .toggle-button {
        --svgFill: var(--systemSecondary-onDark); // Fill for punch-out SVG
        height: 28px;
        width: 28px;
        line-height: 0;
        border-radius: $global-border-radius-medium;
    }

    .toggle-button--info {
        :global(.icon-inner-symbol) {
            fill: rgb(255, 255, 255);
        }
    }

    @media (prefers-contrast: more) {
        .toggle-button {
            --svgFill: var(--keyColor);
        }
    }
</style>
